export enum DashboardLayout {
  ROW = 'row',
  MOSAIC = 'mosaic',
}
